export var TEST_ID_PREFIX = 'logo';
export var LOGO_CLASS = 'logo';